enum ValidationRuleTypeEnum {
    PhoneNumber = 1,
    HealthIdentification,
    PostalCode,
    SocialSecurityNumber,
    PaymentCard
}

export { ValidationRuleTypeEnum };
